import * as tracking from 'dibs-tracking';

export const trackNullResultsDisplayed = () => {
    tracking.trackEvent({
        category: 'null results module interaction',
        action: 'null modules displayed',
        label: 'none',
        value: 0,
    });
};

export const trackNullResultsFollowSearch = () => {
    tracking.trackEvent({
        category: 'search favoriting',
        action: 'search added',
        label: 'null results',
        value: 0,
    });
};

export const trackL1ModuleClick = l1Name => {
    tracking.trackEvent({
        category: 'null results module interaction',
        action: 'l1 link clicked',
        label: l1Name.toLowerCase(),
        value: 0,
    });
};

export const trackL2ModuleClick = (l1Name, primary) => {
    const description = primary ? 'primary' : 'secondary';
    tracking.trackEvent({
        category: 'null results module interaction',
        action: 'l2 link clicked',
        label: `${l1Name.toLowerCase()} | ${description} l2`,
        value: 0,
    });
};

export const trackCreatorModuleClick = creatorName => {
    tracking.trackEvent({
        category: 'null results module interaction',
        action: 'creator link click',
        label: creatorName,
        value: 0,
    });
};

export const trackRoomModuleClick = roomName => {
    tracking.trackEvent({
        category: 'null results module interaction',
        action: 'room link click',
        label: roomName.toLowerCase(),
        value: 0,
    });
};
